import { createSlice, createSelector } from "@reduxjs/toolkit";
import { IUser } from "./models/user";
import { FULFILLED, PENDING, REJECTED } from "../../constants";
import { getUserDetails, getUserDetailsMe, getUserDetailsV2, getUsers, accountIndex } from "./UserApi";
import { UserType } from "../../../types/state/user";
import { ActorProfileMaster, ActorUserSetting } from "../../../types";
import { maskActorProfile } from "../../../utils/actor";

export const UserSlice = createSlice({
  name: "userSlice",
  initialState: {
    user: {
      id: -1,
      userAccountId: -1,
      firstName: "", 
      lastName: "", 
      osEmpPrivilege: 0,
      groupEmployees: [],
      isSuperUser: 0,
      userTimeZoneId: 0,
      empPrivScheduleTool: false,
      userSettings: [],
      DATETIME_FORMAT: "US",
      CAN_ADD_TIMEOFF: false,
      capturebreak: false,
      allowmobileclocking: false,
      enforcegeofence: false,
      allowofflineclocking: false,
      uuid: "",
      is_otp_enabled: false,
      geotrack_threshold: 10,
      ngw_employee_mobile_version: 1,
    } as ActorProfileMaster,
    users: [] as any[],
    requestState: FULFILLED,
  },
  reducers: {},
  extraReducers: {
    [getUsers.pending.type]: (state, action) => {
      state.requestState = PENDING;
    },
    [getUsers.fulfilled.type]: (state, { payload }) => {
      state.users = [...payload.data];
      state.requestState = FULFILLED;
    },
    [getUsers.rejected.type]: (state, action) => {
      state.requestState = REJECTED;
    },

    [getUserDetails.pending.type]: (state, action) => {
      state.requestState = PENDING;
    },
    [getUserDetails.fulfilled.type]: (state, { payload }) => {
      state.user = {
        ...state.user,
        ...payload,
      };
    },
    [getUserDetails.rejected.type]: (state, action) => {
      state.requestState = REJECTED;
    },

    [getUserDetailsMe.pending.type]: (state, action) => {},

    [getUserDetailsV2.pending.type]: (state, action) => {
      state.requestState = PENDING;
    },
    [getUserDetailsV2.fulfilled.type]: (state, { payload }) => {
      state.user = {
        ...state.user,
        ...payload,
      };
      state.requestState = FULFILLED;
    },
    [getUserDetailsV2.rejected.type]: (state, action) => {
      state.requestState = REJECTED;
    },

    [accountIndex.pending.type]: (state) => {
      state.requestState = PENDING;
    },
    [accountIndex.fulfilled.type]: (state, { payload }) => {
      const profile = maskActorProfile(payload, state.user);
      // console.log("accountIndex masked", profile);
      state.user = {...payload, ...profile};
      state.user.id = payload.os_emp_account_id;
      state.user.userAccountId = payload.os_emp_account_id;
      state.requestState = FULFILLED;
    },
    [accountIndex.rejected.type]: (state) => {
      state.requestState = REJECTED;
    },
  },
});

export const getUserData = createSelector(
  (state: any) => state.user,
  (user: IUser) => user
);

export default UserSlice.reducer;
